import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let FormatDataServiceImpl = class FormatDataServiceImpl {
    formatDate(date, format) {
        return '';
    }
};
FormatDataServiceImpl = __decorate([
    injectable()
], FormatDataServiceImpl);
export { FormatDataServiceImpl };
